import TextType from 'components/ui/TextType';
import React, { useState } from 'react';

const NetworkImageSelector = () => {
  const [activeNode, setActiveNode] = useState(1);
  const [hoveredNode, setHoveredNode] = useState(null);

  // Node positions based on the original SVG
  const nodes = [
    { id: 1, x: 150, y: 50 },
    { id: 2, x: 450, y: 50 },
    { id: 3, x: 50, y: 120 },
    { id: 4, x: 250, y: 90 },
    { id: 5, x: 550, y: 120 },
    { id: 6, x: 100, y: 200 },
    { id: 7, x: 200, y: 180 },
    { id: 8, x: 350, y: 140 },
    { id: 9, x: 400, y: 220 },
    { id: 10, x: 50, y: 280 },
    { id: 11, x: 150, y: 320 },
    { id: 12, x: 250, y: 300 },
    { id: 13, x: 350, y: 280 },
    { id: 14, x: 450, y: 320 },
    { id: 15, x: 550, y: 280 },
    { id: 16, x: 300, y: 400 },
    { id: 17, x: 400, y: 450 },
  ];

  // Image data for each node
  const imageData = {
    1: {
      title: 'فاطمه قاضی',
      description: 'Contemporary urban design',
      color: 'bg-gradient-to-br from-blue-500 to-purple-600',
      image: '../../../../public/assets/01.jpg',
    },
    2: {
      title: 'علی رحیمی',
      description: 'Serene mountain views',
      color: 'bg-gradient-to-br from-green-500 to-teal-600',
      image: '../../../../public/assets/02.jpg',
    },
    3: {
      title: 'رضا شریفی',
      description: 'Metropolitan evening lights',
      color: 'bg-gradient-to-br from-orange-500 to-red-600',
      image: '../../../../public/assets/01.jpg',
    },
    4: {
      title: 'سمیه فراستی',
      description: 'Peaceful coastal scenery',
      color: 'bg-gradient-to-br from-cyan-500 to-blue-600',
    },
    5: {
      title: 'Forest Path',
      description: 'Mystical woodland trail',
      color: 'bg-gradient-to-br from-emerald-500 to-green-600',
    },
    6: {
      title: 'Desert Dunes',
      description: 'Golden sand landscapes',
      color: 'bg-gradient-to-br from-yellow-500 to-orange-600',
    },
    7: {
      title: 'Winter Mountains',
      description: 'Snow-capped peaks',
      color: 'bg-gradient-to-br from-slate-400 to-blue-600',
    },
    8: {
      title: 'Tropical Beach',
      description: 'Paradise island getaway',
      color: 'bg-gradient-to-br from-pink-500 to-rose-600',
    },
    9: {
      title: 'Urban Street',
      description: 'Vibrant city life',
      color: 'bg-gradient-to-br from-indigo-500 to-purple-600',
    },
    10: {
      title: 'Autumn Forest',
      description: 'Fall foliage colors',
      color: 'bg-gradient-to-br from-amber-500 to-red-600',
    },
    11: {
      title: 'Abstract Art',
      description: 'Modern digital creation',
      color: 'bg-gradient-to-br from-violet-500 to-purple-600',
    },
    12: {
      title: 'Technology Hub',
      description: 'Futuristic innovation',
      color: 'bg-gradient-to-br from-blue-500 to-cyan-600',
    },
    13: {
      title: 'Minimalist Space',
      description: 'Clean design aesthetics',
      color: 'bg-gradient-to-br from-gray-500 to-slate-600',
    },
    14: {
      title: 'Garden Bloom',
      description: 'Colorful flower paradise',
      color: 'bg-gradient-to-br from-rose-500 to-pink-600',
    },
    15: {
      title: 'Space Galaxy',
      description: 'Cosmic wonder views',
      color: 'bg-gradient-to-br from-indigo-600 to-purple-700',
    },
    16: {
      title: 'Vintage Classic',
      description: 'Timeless elegance',
      color: 'bg-gradient-to-br from-amber-600 to-yellow-600',
    },
    17: {
      title: 'Future Vision',
      description: "Tomorrow's possibilities",
      color: 'bg-gradient-to-br from-teal-500 to-cyan-600',
    },
  };

  // Connections between nodes
  const connections = [
    [1, 2],
    [1, 3],
    [1, 4],
    [1, 6],
    [1, 7],
    [2, 4],
    [2, 5],
    [2, 8],
    [2, 9],
    [3, 6],
    [3, 10],
    [4, 7],
    [4, 8],
    [5, 9],
    [5, 15],
    [6, 7],
    [6, 10],
    [6, 11],
    [7, 8],
    [7, 11],
    [7, 12],
    [8, 9],
    [8, 12],
    [8, 13],
    [9, 13],
    [9, 14],
    [9, 15],
    [10, 11],
    [11, 12],
    [12, 13],
    [12, 16],
    [13, 14],
    [13, 15],
    [13, 16],
    [14, 15],
    [14, 16],
    [14, 17],
    [15, 17],
    [16, 17],
  ];

  const handleNodeClick = (nodeId) => {
    setActiveNode(nodeId);
  };

  const currentImage = imageData[activeNode];

  return (
    <div className="w-full min-h-screen  text-white">
      {/* Hero Section */}
      <div className="flex flex-col lg:flex-row min-h-screen">
        {/* Left Side - Network Navigator */}

        <div className="lg:w-1/2 flex flex-col justify-center items-center p-8 ">
          <div className="mb-6 text-center">
            <TextType
              text={['مشاوره حقوقی هوشمند با ایران‌داد']}
              typingSpeed={75}
              pauseDuration={1500}
              showCursor={true}
              cursorCharacter="|"
            />
          </div>

          <div className="p-6 rounded-2xl ">
            <svg
              width="600"
              height="500"
              viewBox="0 0 600 500"
              className="max-w-full h-auto">
              {/* Render connections */}
              {connections.map(([nodeA, nodeB], index) => {
                const nodeAData = nodes.find((n) => n.id === nodeA);
                const nodeBData = nodes.find((n) => n.id === nodeB);
                const isHighlighted =
                  activeNode === nodeA || activeNode === nodeB;

                return (
                  <line
                    key={index}
                    x1={nodeAData.x}
                    y1={nodeAData.y}
                    x2={nodeBData.x}
                    y2={nodeBData.y}
                    stroke={isHighlighted ? '#06b6d4' : '#4b5563'}
                    strokeWidth={isHighlighted ? '6' : '3'}
                    opacity={isHighlighted ? 1 : 0.4}
                    className="transition-all duration-300"
                  />
                );
              })}

              {/* Render nodes */}
              {nodes.map((node) => {
                const isActive = activeNode === node.id;
                const isHovered = hoveredNode === node.id;

                return (
                  <g key={node.id}>
                    {/* Glow effect for active node */}
                    {isActive && (
                      <circle
                        cx={node.x}
                        cy={node.y}
                        r="35"
                        fill="url(#glow)"
                        opacity="0.6"
                        className="animate-pulse"
                      />
                    )}

                    {/* Outer ring */}
                    <circle
                      cx={node.x}
                      cy={node.y}
                      r="22"
                      fill={isActive ? '#0891b2' : '#22d3ee'}
                      stroke={isActive ? '#06b6d4' : 'none'}
                      strokeWidth="3"
                      className="cursor-pointer transition-all duration-300 hover:scale-110"
                      onClick={() => handleNodeClick(node.id)}
                      onMouseEnter={() => setHoveredNode(node.id)}
                      onMouseLeave={() => setHoveredNode(null)}
                      style={{
                        filter: isActive
                          ? 'drop-shadow(0 0 20px #06b6d4)'
                          : 'none',
                        transform:
                          isHovered && !isActive ? 'scale(1.1)' : 'scale(1)',
                        transformOrigin: `${node.x}px ${node.y}px`,
                      }}
                    />

                    {/* Inner circle */}
                    <circle
                      cx={node.x}
                      cy={node.y}
                      r="12"
                      fill="white"
                      className="pointer-events-none"
                    />

                    {/* Node number */}
                    <text
                      x={node.x}
                      y={node.y + 4}
                      textAnchor="middle"
                      className="text-xs font-bold fill-gray-700 pointer-events-none select-none">
                      {node.id}
                    </text>
                  </g>
                );
              })}

              {/* Gradient definition for glow effect */}
              <defs>
                <radialGradient id="glow">
                  <stop offset="0%" stopColor="#06b6d4" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#06b6d4" stopOpacity="0" />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>

        {/* Right Side - Image Display */}
        <div className="lg:w-1/2 flex flex-col justify-center items-center p-8">
          <div className="w-full max-w-lg">
            <div
              class={`relative mx-auto border-gray-800 dark:border-gray-800 ${currentImage.color} border-[14px] rounded-[2.5rem] h-[600px] w-[300px]`}>
              <div class="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[72px] rounded-s-lg"></div>
              <div class="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg"></div>
              <div class="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[178px] rounded-s-lg"></div>
              <div class="h-[64px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[142px] rounded-e-lg"></div>
              <div class="rounded-[2rem] overflow-hidden w-[272px] h-[572px] dark:bg-gray-800">
                <h2>{currentImage.title}</h2>
                <img
                  src={currentImage?.image}
                  class="hidden dark:block w-[272px] h-[572px]"
                  alt=""
                />
              </div>
            </div>

            {/* Image Placeholder with Gradient */}
            {/* <div
              className={`w-full h-96 rounded-3xl ${currentImage.color} flex items-center justify-center mb-6 shadow-2xl transition-all duration-500 transform`}>
              <div className="text-center p-8">
                <div className="w-24 h-24 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <span className="text-3xl font-bold text-white">
                    {activeNode}
                  </span>
                </div>
                <div className="text-white text-6xl mb-4">📸</div>
                <p className="text-white text-sm opacity-80">
                  Image placeholder
                </p>
              </div>
            </div> */}

            {/* Image Info */}
            <div className="text-center">
              {/* <h3 className="text-4xl font-bold mb-3 transition-all duration-500">
                {currentImage.title}
              </h3>
              <p className="text-xl text-gray-300 mb-6 transition-all duration-500">
                {currentImage.description}
              </p> */}

              {/* Action Buttons */}
              {/* <div className="flex gap-4 justify-center">
                <button className="px-8 py-3 bg-cyan-600 hover:bg-cyan-700 rounded-full font-semibold transition-all duration-300 transform hover:scale-105">
                  View Details
                </button>
                <button className="px-8 py-3 border border-gray-400 hover:border-white rounded-full font-semibold transition-all duration-300 transform hover:scale-105">
                  Download
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkImageSelector;
